module.exports = __webpack_public_path__ + "img/mobile_scanner.1239f74b.svg";